<iframe sandbox="allow-scripts allow-forms allow-modals allow-popups allow-same-origin" [src]="url"></iframe>
